let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aLKAp")).then(() => parcelRequire('i6O3K'));